import React from 'react'
import IconLabel from '../../common/icon-label'
import { CartPlus } from 'react-bootstrap-icons'
import moment from 'moment'

const EnrollCutoff = ({
    experience = {},
    single
}) => {
    if (experience.enrollCutoff  === undefined) {
        return null
    }
    const cutoff = moment(experience.date).subtract(experience.enrollCutoff, 'days').endOf('day')
    const ended = moment().isAfter(cutoff)
    const label = single ? `Enrollment ${ended ? 'ended' : 'ends'}` : `Sign up ${ended ? 'ended' : 'before'}`
    return (
        <IconLabel
            icon={CartPlus}
        >
            <small>{label} {cutoff.format('ddd, MMM Do h:mm a')}</small>
        </IconLabel>
    )
}

export default EnrollCutoff
